var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col mb-3" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "row no-gutters" }, [
        _c("div", { staticClass: "col-sm-2 enrolled-course-card" }),
        _c("div", { staticClass: "col-sm-10" }, [
          _c("div", { staticClass: "card-body d-flex flex-column h-100" }, [
            _c("h5", { staticClass: "card-title mb-0" }, [
              _vm._v(_vm._s(_vm.course.name))
            ]),
            _c(
              "div",
              {
                staticClass:
                  "card-text course-data mt-3 h-100 d-flex flex-column justify-content-around"
              },
              [
                _c(
                  "div",
                  [
                    _vm.course.school_name
                      ? _c("omegaup-markdown", {
                          attrs: {
                            "full-width": true,
                            markdown: _vm.ui.formatString(
                              _vm.T.courseCardImpartedBy,
                              {
                                school_name: _vm.course.school_name
                              }
                            )
                          }
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center"
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.T.courseCardProgress) + " "),
                        _c("div", { staticClass: "progress w-75" }, [
                          _c("div", {
                            staticClass: "progress-bar",
                            style: "width: " + _vm.course.progress + "%",
                            attrs: {
                              role: "progressbar",
                              "aria-valuenow": _vm.course.progress,
                              "aria-valuemin": "0",
                              "aria-valuemax": "100"
                            }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "text-center mt-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary text-white",
                      attrs: {
                        role: "button",
                        href: "/course/" + _vm.course.alias + "/"
                      }
                    },
                    [_vm._v(_vm._s(_vm.T.courseCardCourseResume))]
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }